export const isEmptyObj = obj => {
  for (var i in obj) {
    return false;
  }
  return true;
}

export const cmdmsg = msg => {
  switch (msg) {
    case "upload":
      return "上传(upload)"
      break;
    case "init":
      return "初始化(init)"
      break;
    case "upscreen":
      return "上课(upscreen)"
      break;
    case "downscreen":
      return "下课(downscreen)"
      break
    case "closerank":
      return "关闭排行榜(closerank)"
    case "update":
      return "更新数据(update)"
    case "checkupdate":
      return "更新版本(checkupdate)"
    default:
      return msg
  }
}
export const format = (date, fmt = 'YYYY-MM-DD HH:mm:ss') => {
  var o = {
      'M+': date.getMonth() + 1,
      'D+': date.getDate(),
      'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      'S': date.getMilliseconds()
    }
    var week = {
      '0': '\u65e5',
      '1': '\u4e00',
      '2': '\u4e8c',
      '3': '\u4e09',
      '4': '\u56db',
      '5': '\u4e94',
      '6': '\u516d'
    }
    if (/(Y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
}

export const validatePhone = type => (rule, value, callback) => {
  if (value === '') {
    callback(new Error(`请输入${type}`));
  } else {
    if (!/^\d{9,11}$/.test(value)) {
      callback(new Error(`${type}格式错误`));
    }
    callback();
  }
};

export const validateMail = type => (rule, value, callback) => {
  if (value === '') {
    callback(new Error(`请输入${type}`));
  } else {
    if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value)) {
      callback(new Error(`${type}格式错误`));
    }
    callback();
  }
};

export const validatePassword = type => (rule, value, callback) => {
  if (value === '') {
    callback(new Error(`请输入${type}`));
  } else {
    if (!/^[a-zA-Z0-9_]{6,20}$/.test(value)) {
      callback(new Error(`${type}格式错误`));
    }
    callback();
  }
};
